// extracted by mini-css-extract-plugin
export var callCard = "_s2-0";
export var callMessageButton = "_s2-1";
export var helpIcon = "_s2-3";
export var helpIconContainer = "_s2-4";
export var verticalDivider = "_s2-2";